export default __webpack_public_path__ + "static/N0163-3644bbab9ed5fda539016b07075fb749.png";